// Конфігурація для App Store та Google Play посилань
export const APP_CONFIG = {
  ios: {
    // ваш App Store ID
    appStoreId: '6738004733',
    appStoreUrl: 'https://apps.apple.com/app/id6738004733',
    // Альтернативно можна використовувати itms-apps схему
    alternativeUrl: 'itms-apps://apps.apple.com/app/id6738004733'
  },
  android: {
    // Package name з assetlinks.json
    packageName: 'com.offerandroid',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.offerandroid',
    // Альтернативно можна використовувати market схему
    alternativeUrl: 'market://details?id=com.offerandroid'
  }
};

// Функція для генерації intent URL для Android
export const generateAndroidIntentUrl = (currentUrl, fallbackUrl = null) => {
  const path = window.location.pathname + window.location.search;
  const fallback = fallbackUrl || currentUrl;

  return `intent://${window.location.host}${path}#Intent;scheme=https;package=${APP_CONFIG.android.packageName};S.browser_fallback_url=${encodeURIComponent(fallback)};end`;
};

// Функція для визначення типу пристрою
export const detectDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isAndroid = /android/.test(userAgent);
  const isMacOS = /macintosh|mac os x/.test(userAgent) && !('ontouchend' in document);
  const isWindows = /windows/.test(userAgent);

  return {
    isIOS,
    isAndroid,
    isMacOS,
    isWindows,
    isMobile: isIOS || isAndroid,
    isDesktop: !isIOS && !isAndroid
  };
};

export default APP_CONFIG;